import script from "./ChoiceBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChoiceBox.vue?vue&type=script&setup=true&lang=ts"

import "./ChoiceBox.vue?vue&type=style&index=0&id=25b42e46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b42e46"]])

export default __exports__